<template>
    <Transition>
        <div style="margin-right: 10px;" v-if="candidate">
        <div class="form container px-2">
        <h5><b>SERVICE WITHIN REPORTING PERIOD</b></h5>

        <!--Positions held-->
        <div class="mb-4 text-start">
            <div>
                <b>
                    1. &nbsp; &nbsp;Positions held in the reporting period:
                </b>
                <span @click="resetEdit()" class="ms-3">
                    <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#positionsHeld"><i class="fa fa-plus" aria-hidden="true"></i></button>
                </span>
            </div>
            <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=positionsHeld :type='"positionsHeld"' />
        </div>

        <!-- Positions held modal -->
        <div class="modal fade" id="positionsHeld" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="positionsHeldLabel">Position Held</h1>
                        <button id="closePositionsHeld" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-start ms-3">
                        <div class="mb-3">
                            <label for="positionHeld" class="form-label">Position Details:</label>
                            <span>
                                <textarea rows="4" v-model="positionHeld" type="text" class="form-control"
                                    id="positionHeld"></textarea>
                            </span>
                            <br>
                            <div>
                                <label for="positionHeldUrl" class="form-label">Google Drive Link:</label>
                                <input v-model="positionHeldUrl" type="text" class="form-control" id="positionHeldUrl">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails('positionHeld')" type="button" class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <!--duty schedule-->
        <div class="mb-4 text-start">
            <div class="d-flex">
                <b>
                    2. &nbsp; &nbsp;Schedule of duties in the University during the reporting year (give
                    brief description):
                </b>
                <span @click="resetEdit()" class="ms-3">
                    <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#dutySchedules"><i class="fa fa-plus" aria-hidden="true"></i></button>
                </span>
            </div>
            <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=dutySchedules :type='"dutySchedules"' />
        </div>

        <!-- duty schedule modal -->
        <div class="modal fade" id="dutySchedules" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="dutySchedulesLabel">Duty Schedule</h1>
                        <button id="closeDutySchedule" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-start ms-3">
                        <div class="mb-3">
                            <label for="dutySchedule" class="form-label">Duty Details:</label>
                            <span>
                                <textarea rows="4" v-model="dutySchedule" type="text" class="form-control"
                                    id="dutySchedule"></textarea>
                            </span>
                            <br>
                            <div hidden>
                                <label for="dutyScheduleUrl" class="form-label">Google Drive Link:</label>
                                <input v-model="dutyScheduleUrl" type="text" class="form-control" id="dutyScheduleUrl">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails('dutySchedule')" type="button" class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <!--committee membership-->
        <div class="mb-4 text-start">
            <div class="d-flex">
                <b>
                    3. &nbsp; &nbsp;Activities in the University in the reporting period outside normal schedule calling for special mention (e.g. membership of committee(s), special assignments, extra responsibilities, etc.)
                </b>
                <span @click="resetEdit()" class="ms-3">
                    <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#committeeMemberships"><i class="fa fa-plus" aria-hidden="true"></i></button>
                </span>
            </div>
            <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=committeeMemberships :type='"committeeMemberships"' />
        </div>

        <!-- committee membership modal -->
        <div class="modal fade" id="committeeMemberships" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="committeeMembershipsLabel">Committee Membership</h1>
                        <button id="closeCommitteeMembership" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-start ms-3">
                        <div class="mb-3">
                            <label for="committeeMembership" class="form-label">Committee Details:</label>
                            <span>
                                <textarea rows="4" v-model="committeeMembership" type="text" class="form-control"
                                    id="committeeMembership" placeholder="e.g. Since March, 2024, Member of the Senate Computer Services Committee of Rivers State University."></textarea>
                            </span>
                            <br>
                            <div>
                                <label for="committeeMembershipUrl" class="form-label">Google Drive Link:</label>
                                <input v-model="committeeMembershipUrl" type="text" class="form-control" id="committeeMembershipUrl" placeholder="e.g. https://drive.google.com/file/d/0B2qNXhBbYeLpc3RhcnRlcl9maWxl/view?usp=sharing&resourcekey=0-KcYGWMmUv-6g0bfg046jCg">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails('committeeMembership')" type="button" class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <!--community activities / service-->
        <div class="mb-4 text-start">
            <div class="d-flex align-items-center mb-3">
                <b>
                    4. &nbsp; &nbsp;Relevant Community activities in the reporting period:
                </b>
                <span @click="resetEdit()" class="ms-3">
                    <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#communityServices"><i class="fa fa-plus" aria-hidden="true"></i></button>
                </span>
            </div>
            <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=communityServices :type='"communityServices"' />
        </div>


        <!-- communityService modal -->
        <div class="modal fade" id="communityServices" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="communityServiceLabel">Community Service</h1>
                        <button id="closeCommunity" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-start ms-3">
                        <div class="mb-3">
                            <label for="communityService" class="form-label">Community Service Details:</label>
                            <span>
                                <textarea rows="4" v-model="communityService" type="text" class="form-control"
                                    id="communityService" placeholder="e.g. Since March, 2024, Member of the Newsletter Committee of the Nigerian Institute of Management, Port Harcourt Chapter."></textarea>
                            </span>
                            <br>
                            <div>
                                <label for="communityServiceUrl" class="form-label">Letter Google Drive Link:</label>
                                <input v-model="communityServiceUrl" type="text" class="form-control" id="communityServiceUrl" placeholder="e.g. https://drive.google.com/file/d/0B2qNXhBbYeLpc3RhcnRlcl9maWxl/view?usp=sharing&resourcekey=0-KcYGWMmUv-6g0bfg046jCg">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails('communityService')" type="button" class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="mb-4 mt-3">
            <div>
                <p class="mb-0">
                    <b>5. &nbsp; &nbsp;State any significant gain in experience during the reporting period:</b>
                </p>
            </div>
            <div>
                <textarea v-model="experienceGained" type="text" class="form-control pb-0"></textarea>
            </div>
        </div>

        <div class="mb-4 mt-3">
            <div>
                <p class="mb-0">
                    <b>6. &nbsp; &nbsp;Which University activities do you think you did especially well during
                        the reporting period:</b>
                </p>
            </div>
            <div>
                <textarea v-model="serviceExcelledIn" type="text" class="form-control pb-0"></textarea>
            </div>
        </div>

        <div class="mb-4 mt-3">
            <div>
                <p class="mb-0">
                    <b>7. &nbsp; &nbsp;Were there any University activities you performed not very
                        satisfactory?</b>
                </p>
            </div>
            <div>
                <textarea v-model="unsatisfactoryActivities" type="text" class="form-control pb-0"></textarea>
            </div>
        </div>

        <div class="mb-4 mt-3">
            <div>
                <p class="mb-0">
                    <b>8. &nbsp; &nbsp;If yes, please explain the reason:</b>
                </p>
            </div>
            <div>
                <textarea v-model="unsatisfactoryActivitiesReasons" type="text" class="form-control pb-0"></textarea>
            </div>
        </div>

        <div class="mb-4 mt-3">
            <div>
                <p class="mb-0">
                    <b>9. &nbsp; &nbsp;How would you describe your relationship with your senior officers?</b>
                </p>
            </div>
            <div>
                <textarea v-model="seniorOfficerRelationship" type="text" class="form-control pb-0"></textarea>
            </div>
        </div>

        <div class="mb-4 mt-3">
            <div>
                <p class="mb-0">
                    <b>10. &nbsp; &nbsp;How would you describe your relationship with your colleagues?</b>
                </p>
            </div>
            <div>
                <textarea v-model="colleaguesRelationship" type="text" class="form-control pb-0"></textarea>
            </div>
        </div>

        <div class="mb-4 mt-3">
            <div>
                <p class="mb-0">
                    <b>11. &nbsp; &nbsp;How would you describe your relationship with staff working under
                        you?</b>
                </p>
            </div>
            <div>
                <textarea v-model="subordinateRelationship" type="text" class="form-control pb-0"></textarea>
            </div>
        </div>

        <div class="mb-4 mt-3">
            <div>
                <p class="mb-0">
                    <b>12. &nbsp; &nbsp;Other information that may assist the Committee in determining your
                        suitability for promotion, if you are eligible to be considered</b>
                </p>
            </div>
            <div>
                <textarea v-model="otherInfo" type="text" class="form-control mb-4"></textarea>
            </div>
        </div>

        <div class="d-flex flex-row-reverse py-5">
            <button v-if="!candidate.submitted" type="button" class="btn btn-success" data-bs-toggle="modal" data-bs-target="#staticBackdrop">Submit for Appraisal</button>
            <button @click="saveSection('save')" type="button" class="btn btn-success me-3">Save Section</button>
            <button @click="saveSection('previous')" type="button" class="btn btn-success me-3">Previous Section</button>
        </div>
        <!--Submit to supervisor modal-->
        <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Confirmation</h5>
                        <button id="closeSubmit" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3 mx-4 text-start"><b>Are you sure you want to submit now?</b></div>
                    </div>
                    <div class="modal-footer">
                        <button @click="submit()" type="button" class="btn btn-success">Yes, Submit</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</Transition></template>
<script>
import DataService from '../../services/dataservice';

export default {
    name: 'section2',
    emits: ['toggleLoader', 'setSection', 'submitted'],
    data() {
        return {
            candidate: '',
            positionHeld: '',
            positionHeldUrl: '',
            positionsHeld: [],
            dutySchedule: '',
            dutyScheduleUrl: '',
            dutySchedules: [],
            committeeMembership: '',
            committeeMembershipUrl: '',
            committeeMemberships: [],
            communityService: '',
            communityServiceUrl: '',
            communityServices: [],
            experienceGained: '',
            serviceExcelledIn: '',
            unsatisfactoryActivities: '',
            unsatisfactoryActivitiesReasons: '',
            seniorOfficerRelationship: '',
            colleaguesRelationship: '',
            subordinateRelationship: '',
            otherInfo: '',

            hodEmail: '',
            deanEmail: '',
            key: 0
        }
    },
    created() {
        this.$emit('setSection', 'Section II');
        this.setData()
    },
    methods: {
        resetEdit(){
            //removes edit section if present on the page
            for (var i=0; i < this.positionsHeld.length; i++) {
                this.positionsHeld[i].editing = false
            }
            for (var i=0; i < this.dutySchedules.length; i++) {
                this.dutySchedules[i].editing = false
            }
            for (var i=0; i < this.committeeMemberships.length; i++) {
                this.committeeMemberships[i].editing = false
            }
            for (var i=0; i < this.communityServices.length; i++) {
                this.communityServices[i].editing = false
            }
        },
        joinDetails(category) {
            this.$emit('toggleLoader');

            if (category == 'positionHeld') {
                if (this.positionHeld) {
                    this.positionsHeld.unshift({ data: this.positionHeld, fileUrl: !/^https?:\/\//i.test(this.positionHeldUrl) ? this.positionHeldUrl ? "https://" + this.positionHeldUrl : '' : this.positionHeldUrl })
                    document.getElementById('closePositionsHeld').click();
                } else {
                    alert('Fill position details.')
                }
                this.positionHeld = '';
                this.positionHeldUrl = '';
            }

            if (category == 'dutySchedule') {
                if (this.dutySchedule){
                    this.dutySchedules.unshift({ data: this.dutySchedule, fileUrl: !/^https?:\/\//i.test(this.dutyScheduleUrl) ? this.dutyScheduleUrl ? "https://" + this.dutyScheduleUrl : '' : this.dutyScheduleUrl})
                    document.getElementById('closeDutySchedule').click();
                } else {
                    alert('Fill duty details.')
                }
                this.dutySchedule = '';
                this.dutyScheduleUrl = ''
            }

            if (category == 'committeeMembership') {
                if (this.committeeMembership){
                    this.committeeMemberships.unshift({ data: this.committeeMembership, fileUrl: !/^https?:\/\//i.test(this.committeeMembershipUrl) ? this.committeeMembershipUrl ? "https://" + this.committeeMembershipUrl : '' : this.committeeMembershipUrl })
                    document.getElementById('closeCommitteeMembership').click();
                } else {
                    alert('Fill committee membership details.')
                }
                this.committeeMembership = '';
                this.committeeMembershipUrl = '';
            }

            if (category == 'communityService') {
                if (this.communityService){
                    this.communityServices.unshift({ data: this.communityService, fileUrl: !/^https?:\/\//i.test(this.communityServiceUrl) ? this.communityServiceUrl ? "https://" + this.communityServiceUrl : '' : this.communityServiceUrl })
                    document.getElementById('closeCommunity').click();
                } else {
                    alert('Fill community service details.')
                }
                this.communityService = '';
                this.communityServiceUrl = '';
            }

            this.key += 1;
            this.$emit('toggleLoader');
        },
        async saveSection(page) {
            this.$emit('toggleLoader');

            var dataDetails = {
                positionsHeld: this.positionsHeld,
                dutySchedules: this.dutySchedules,
                committeeMemberships: this.committeeMemberships,
                communityServices: this.communityServices,
                experienceGained: this.experienceGained,
                serviceExcelledIn: this.serviceExcelledIn,
                unsatisfactoryActivities: this.unsatisfactoryActivities,
                unsatisfactoryActivitiesReasons: this.unsatisfactoryActivitiesReasons,
                seniorOfficerRelationship: this.seniorOfficerRelationship,
                colleaguesRelationship: this.colleaguesRelationship,
                subordinateRelationship: this.subordinateRelationship,
                otherInfo: this.otherInfo
            }

            const candidate = await DataService.saveData(dataDetails)

            if (candidate) {
                this.candidate = candidate;
                this.positionsHeld = candidate.nonacademicStaff ? candidate.nonacademicStaff.positionsHeld ? candidate.nonacademicStaff.positionsHeld : [] : [];
                this.dutySchedules = candidate.nonacademicStaff ? candidate.nonacademicStaff.dutySchedules ? candidate.nonacademicStaff.dutySchedules : [] : [];
                this.committeeMemberships = candidate.committeeMemberships ? candidate.committeeMemberships : [];
                this.communityServices = candidate.communityServices ? candidate.communityServices : [];
                this.experienceGained = candidate.experienceGained ? candidate.experienceGained : '';
                this.serviceExcelledIn = candidate.serviceExcelledIn ? candidate.serviceExcelledIn : '';
                this.unsatisfactoryActivities = candidate.unsatisfactoryActivities ? candidate.unsatisfactoryActivities : '';
                this.unsatisfactoryActivitiesReasons = candidate.unsatisfactoryActivitiesReasons ? candidate.unsatisfactoryActivitiesReasons : '';
                this.seniorOfficerRelationship = candidate.seniorOfficerRelationship ? candidate.seniorOfficerRelationship : '';
                this.colleaguesRelationship = candidate.colleaguesRelationship ? candidate.colleaguesRelationship : '';
                this.subordinateRelationship = candidate.subordinateRelationship ? candidate.subordinateRelationship : '';
                this.otherInfo = candidate.nonacademicStaff ? candidate.nonacademicStaff.otherInfo ? candidate.nonacademicStaff.otherInfo : '': '';
                this.hodEmail = candidate.hodEmail ? candidate.hodEmail : '' ;
                this.deanEmail = candidate.deanEmail ? candidate.deanEmail : '';
                this.key += 1
            }

            this.$emit('toggleLoader');

            if (page == 'save' && candidate){
                alert('Section saved')
            } else if (page == 'previous' && candidate){
                this.$router.push('/section1')
            }
        },
        async submit(){
            this.$emit('toggleLoader');

            var dataDetails = {
                positionsHeld: this.positionsHeld,
                dutySchedule: this.dutySchedule,
                committeeMemberships: this.committeeMemberships,
                communityServices: this.communityServices,
                experienceGained: this.experienceGained,
                serviceExcelledIn: this.serviceExcelledIn,
                unsatisfactoryActivities: this.unsatisfactoryActivities,
                unsatisfactoryActivitiesReasons: this.unsatisfactoryActivitiesReasons,
                seniorOfficerRelationship: this.seniorOfficerRelationship,
                colleaguesRelationship: this.colleaguesRelationship,
                subordinateRelationship: this.subordinateRelationship,
                otherInfo: this.otherInfo,

                hodEmail: this.hodEmail.trim().toLowerCase(),
                deanEmail: this.deanEmail.trim().toLowerCase(),

                submitted: true
            }

            /*
            if (this.hodEmail && this.deanEmail) {
                
                var regex = /^[\w\-\.\+]+\@[a-zA-Z0-9\. \-]+\.[a-zA-z0-9]{2,4}$/;
                if (this.hodEmail.match(regex) == null){
                    alert ('Enter the correct Supervisor email');
                    this.$emit('toggleLoader');
                    return
                }

                if (this.deanEmail.match(regex) == null){
                    alert ('Enter the correct HOD email');
                    this.$emit('toggleLoader');
                    return
                }
                

                document.getElementById('closeSubmit').click();
                
                const candidate = await DataService.saveData(dataDetails);

                if (candidate) {
                    this.candidate = candidate
                    alert('Your appraisal application has successfully been submitted');
                }
            } else {
                alert('Fill the Supervisor and HOD emails')
            }
            */

            document.getElementById('closeSubmit').click();
                
            const candidate = await DataService.saveData(dataDetails);

            if (candidate) {
                this.candidate = candidate
                alert('Your appraisal application has successfully been submitted');
                this.$emit('toggleLoader');
                this.$router.push({ path: `/section1` });
                return
            }
            
            this.$emit('toggleLoader');
        },
        deleteItem(index, item) {
            if (item == 'committeeMembership') {
                this.committeeMemberships.splice(index, 1);
                return
            }

            if (item == 'communityService') {
                this.communityServices.splice(index, 1);
                return
            }
        },
        async setData() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            
            this.$emit('toggleLoader');

            const candidate = await DataService.getCandidate(JSON.parse(window.localStorage['user'])._id);

            if (candidate) {
                if ((candidate.staffType == "Academic Teaching") || (candidate.staffType == "Research") || (candidate.staffType == "Library")) {
                    this.$emit('toggleLoader');
                    this.$router.push({ path: `/sectiona` });
                    return
                }
                this.$emit('submitted', candidate.submitted);
                this.candidate = candidate;
                this.positionsHeld = candidate.nonacademicStaff ? candidate.nonacademicStaff.positionsHeld ? candidate.nonacademicStaff.positionsHeld : [] : [];
                this.dutySchedules = candidate.nonacademicStaff ? candidate.nonacademicStaff.dutySchedules ? candidate.nonacademicStaff.dutySchedules : [] : [];
                this.committeeMemberships = candidate.committeeMemberships ? candidate.committeeMemberships : [];
                this.communityServices = candidate.communityServices ? candidate.communityServices : [];
                this.experienceGained = candidate.experienceGained ? candidate.experienceGained : '';
                this.serviceExcelledIn = candidate.serviceExcelledIn ? candidate.serviceExcelledIn : '';
                this.unsatisfactoryActivities = candidate.unsatisfactoryActivities ? candidate.unsatisfactoryActivities : '';
                this.unsatisfactoryActivitiesReasons = candidate.unsatisfactoryActivitiesReasons ? candidate.unsatisfactoryActivitiesReasons : '';
                this.seniorOfficerRelationship = candidate.seniorOfficerRelationship ? candidate.seniorOfficerRelationship : '';
                this.colleaguesRelationship = candidate.colleaguesRelationship ? candidate.colleaguesRelationship : '';
                this.subordinateRelationship = candidate.subordinateRelationship ? candidate.subordinateRelationship : '';
                this.otherInfo = candidate.nonacademicStaff ? candidate.nonacademicStaff.otherInfo ? candidate.nonacademicStaff.otherInfo : '': '';
                this.hodEmail = candidate.hodEmail ? candidate.hodEmail : '' ;
                this.deanEmail = candidate.deanEmail ? candidate.deanEmail : '';
                this.key += 1
            }

            this.$emit('toggleLoader');
        }
    }
}
</script>